import React from 'react'
import { useTranslation } from 'react-i18next'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { useCopyToClipboard } from '~/hooks/useCopyToClipboard'
import { useLogEvent } from '~/hooks/useLogEvent'
import { assertExists } from '~/utils'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useDocumentReportId } from '../hooks/useDocumentReportId'
import { useMainQueryData } from '../hooks/useMainQuery'

export const DocumentReportShareButton = () => {
  const { t } = useTranslation()
  const brandAccountId = useBrandAccountId()
  const documentReportId = useDocumentReportId()
  const copyToClipboard = useCopyToClipboard()
  const documentReport = useMainQueryData()
  assertExists(documentReport, t('assertion_failed'))
  const logEvent = useLogEvent()
  const handleClick = React.useCallback<EH<IconButtonProps, 'onClick'>>(() => {
    const url = `${window.location.origin}${compile('documentReportEdit', {
      brandAccountId,
      documentReportId,
    })}`
    copyToClipboard(url, {
      notificationText: t('documentreport_title_url_copied_to_clipboard', {
        documentReport,
      }),
    })
    logEvent('Share document')
  }, [
    brandAccountId,
    copyToClipboard,
    documentReport,
    documentReportId,
    logEvent,
    t,
  ])

  return <IconButton fillMode="outline" icon="share" onClick={handleClick} />
}
